<template>
  <!-- CANCEL BUTTON WITH DIALOG -->
  <v-dialog persistent v-model="confirmCancel" max-width="450" >

    <!-- THE BUTTON ITSELF -->
    <template v-slot:activator="attrs">
      <v-btn
          text="CANCEL"
          prepend-icon="fa fa-times"
          rounded
          color="red"
          variant="outlined"
          @click="confirmCancel = true"
      />
    </template>

    <!-- CONFIRM DIALOG -->
    <v-card>
      <v-card-title><b>Confirm Exit</b></v-card-title>
      <v-divider/>
      <v-card-text>Any unsaved data will be lost. This action cannot be undone.</v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue" rounded @click="confirmCancel = false">CONTINUE EDITING</v-btn>
        <v-btn color="red" rounded variant="flat" @click="router.visit($routes.project(projectId))">EXIT</v-btn>
      </v-card-actions>
    </v-card>

  </v-dialog>
</template>

<script setup>
import { router } from "@inertiajs/vue3";
import * as $routes from '../packs/routes'
import {ref} from "vue";

const confirmCancel = ref(false);

const props = defineProps({
  projectId: {
    type: Number,
    required: true
  }
})
</script>

<style scoped>

</style>